import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const search = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Verify/Search", params);
};


const getById = (id) => {
  const params = {
    id,
  };

  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/Verify/GetById", params);
};

const updateItem = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/Update?userId=" +
      userData.userId(),
    params
  );
};


const deleteItem = (id) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/Delete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const getVerifyDeps = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/GetVerifyDep"      
  );
}

const getVerifyMinistries = (id) => {

  const params = {id}

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/GetVerifyMinistries",
      params,  
  );
}

const getAllVerifyMinistries = () => {


  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/GetAllVerifyMinistries",
  );
}

const getVerifyStatuses = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/GetVerifyStatuses"      
  );
}

const getVerifyFlags = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/Verify/GetVerifyFlags"      
  );
}

export {
  search,
  getById,
  updateItem,
  deleteItem,
  getVerifyDeps,
  getAllVerifyMinistries,
  getVerifyMinistries,
  getVerifyStatuses,
  getVerifyFlags,
};
